import React from "react";

function MobileView(){
    return(
        <div>
          <div id="section-aamer-app" className="py-2">
            <div className="d-flex justify-content-center my-2">
              <img
                src="https://aamerhub.ae/assets/images/logos/aamer_transparent%20background.png"
                width="150px"
                height="auto"
                alt="logo"
                className="auth-logo"
              />
            </div>
            <div className="d-flex justify-content-center my-2">
              <div style={{ width: "150px" }}>
                <a
                  href="https://apps.apple.com/ae/app/aamer-app/id1618423347"
                  target="_blank"
                >
                  <img
                    src="https://aamerhub.ae/assets/images/apple.png"
                    width="150px"
                  ></img>
                </a>
              </div>
            </div>
            <div className="d-flex justify-content-center my-2">
              <div style={{ width: "150px" }}>
                <a
                  href="https://apps.apple.com/ae/app/aamer-app/id1618423347"
                  target="_blank"
                >
                  <img
                    src="https://aamerhub.ae/assets/images/apple.png"
                    width="150px"
                  ></img>
                </a>
              </div>
            </div>
          </div>
          <div className="container" style={{paddingLeft: "30px"}}>
            <div className="row justify-content-center mb-5">
              <div className="col-md-7 text-center border-primary">
                <h2 className="font-weight-light red-color">Contact us</h2>
              </div>
            </div>
            <div className="row">
              <div >
                <div className="col-md-6">
                  <p className="mb-0 font-weight-light" style={{fontSize: "large", fontWeight: "bold"}}>Address</p>
                  <p className="mb-3">
                    AAMER DIGITAL HUB, PO BOX : 2913, Abu Dhabi, United Arab
                    Emirates
                  </p>
                  <p className="mb-0 font-weight-bold" style={{fontSize: "large", fontWeight: "bold"}}>Phone</p>
                  <p className="mb-3">
                    <a href="#">+971 26519000</a>
                  </p>
                  <p className="mb-0 font-weight-bold" style={{fontSize: "large", fontWeight: "bold"}}>Email Address</p>
                  <p className="mb-3">
                    <a href="#">info@aamerhub.ae</a>
                  </p>
                  <div></div>
                  <p></p>
                  <p className="mb-0 font-weight-bold" style={{fontSize: "large", fontWeight: "bold"}}>Website</p>
                  <p className="mb-3">
                    <a href="#" className="blue-color">
                      www.aamerhub.ae
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}

export default MobileView;